import { Component, Input, OnChanges, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Distributor, HttpDataService } from 'core/index';
import { BrokerCreditsDealerService } from '../broker-credits-dealer.service';

@Component({
  selector: 'lms-broker-credits-purchases',
  templateUrl: './broker-credits-purchases.component.html',
  styleUrls: ['./broker-credits-purchases.component.scss']
})
export class BrokerCreditsPurchasesComponent implements OnInit, OnChanges {
  @Input() distributor: Distributor;
  @Input() listId = 'DISTRIBUTOR_CREDITS_PURCHASES_LIST';
  @Input() hideCredits = false;
  public dataService: HttpDataService;
  public purchases: any[];
  public filters: Map<string, string>;

  constructor(public dealerService: BrokerCreditsDealerService, public route: ActivatedRoute) {}

  ngOnInit() {
    this.route.data.subscribe((data) => {
      if (!this.distributor && data.distributor) {
        this.distributor = data['distributor'];
        this.setDataservice();
      }
    });
  }

  ngOnChanges() {
    this.setDataservice();
  }

  setDataservice() {
    if (this.distributor) {
      this.dataService = this.dealerService.getPurchasesDataService(this.distributor);
    }
  }

  setCollection(purchases) {
    this.purchases = purchases;
  }
}
